<script setup lang="ts">
const open = ref(false);

const popoverUi = { content: "bg-elevated ring-0 shadow-[0_2px_12px_0_rgba(0,0,0,0.04)] rounded-lg" };

defineShortcuts({
  o: () => (open.value = !open.value),
});
</script>

<template>
  <UPopover v-model:open="open" :ui="popoverUi" :content="{ side: 'left', align: 'start' }">
    <UButton
      square
      color="blue"
      data-testid="identifier-help-button"
      :title="$t('field.identifier.help.button')"
      class="p-0 size-4.5 bg-blue-600 hover:bg-blue-700! aria-expanded:bg-elevated hover:aria-expanded:bg-blue-600 aria-expanded:text-blue-600 hover:aria-expanded:text-blue-200 flex items-center justify-center rounded-full"
    >
      <UIcon name="icon:help" class="size-3" />
    </UButton>

    <template #content>
      <div data-testid="identifier-help-content" class="text-sm/normal text-primary p-4 max-w-56">
        <h3 class="font-semibold mb-1">{{ $t("field.identifier.help.title") }}</h3>
        <i18n-t keypath="field.identifier.help.text" tag="p" scope="global">
          <template #break><br /></template>
        </i18n-t>
      </div>
    </template>
  </UPopover>
</template>
